import React from 'react';

import { Icon } from 'semantic-ui-react'

export default function Footer (props) {

    return (<footer>
    <p>Copyright 2022 <Icon name='copyright outline' /> - Mentions légales <Icon name='address card outline' /> - Assistance <Icon name='question circle outline' /></p>
    </footer>)
}